<template>
    <div class="table table-responsive">
        <div v-if="reservations.length === 0">Er zijn voor jou nog geen reserveringen bekend.</div>
        <table
            v-else
            class="table">
            <thead>
                <tr>
                    <th>Reserverings nr.</th>
                    <th>Contactpersoon</th>
                    <th>Referentie</th>
                    <th>Start datum</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr
                v-for="reservation in reservations"
                :key="reservation.ReservationID"
                :class="rowColor(reservation)">
                    <td>{{ reservation.ReservationID }}</td>
                    <td>{{ reservation.ContactID }}</td>
                    <td>{{ reservation.Reference }}</td>
                    <td>{{ formatDate(reservation.DateTimeRentalStart) }}</td>
                    <td>{{ reservation.Status | translate }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from 'moment'
import TranslationService from '@/services/TranslationService'
import CustomerService from '@/services/CustomerService.js'

export default {
    filters: {
        translate (value) {
            return TranslationService.get(value)
        }
    },
    data () {
        return {
            reservations: []
        }
    },
    created () {
        this.getReservations()
    },
    methods: {
        async getReservations () {
            this.reservations = await CustomerService.getReservations(this.$store.getters.user.CustomerID)
        },
        formatDate: function (value) {
            return moment(value).format('DD-MM-YYYY')
        },
        rowColor: function (reservation) {
            return {
                active: reservation.Status === 'Active',
                'table-success': reservation.Status === 'Active'
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Account/ReservationsTable.vue